import { calcPromotionByBindCard, checkPromotion } from "@/api/middle.js"
import { base64Decode, clientKeyMap } from "@/utils/utils"

export default {
  data() {
    return {
      paymentMethod: null,
      payMethodsPromo: null,
      paymentVisible: false,
      paymentStatus: "init",
      processInstance: null,
      salePrice: 0,
      curMerchantId: ""
    }
  },
  computed: {
    paymentTitle() {
      let title = ""
      if (this.paymentMethod?.paymentMethodId === 801) {
        if (this.paymentStatus === "init") {
          title = this.$t("checkout.addNewCard")
        } else if (this.paymentStatus === "confrim") {
          title = this.$t("checkout.bindNewCardAndPay")
        } else if (this.paymentStatus === "pay") {
          title = this.$t("checkout.DSecureAuth")
        }
      } else {
        title = this.$t("checkout.DSecureAuth")
      }
      return title
    }
  },
  watch: {
    paymentMethod(newVal) {
      const key = newVal ? `${newVal.paymentMethodId}_${newVal.signNum || "null"}` : ""
      this.salePrice = this.payMethodsPromo && key ? this.payMethodsPromo[key]?.salePrice || 0 : 0
    }
  },
  methods: {
    async initPaymentSDK({ merchantId }) {
      this.curMerchantId = merchantId
      this.loading = true
      try {
        this.paymentMethod = await this.$sdk.init({
          merchantId,
          clientKey: clientKeyMap[merchantId]
        })
      } catch (error) {
        console.log("error", error)
      } finally {
        this.loading = false
      }
    },
    getPriceFromPromoList() {
      const key = this.paymentMethod
        ? `${this.paymentMethod.paymentMethodId}_${this.paymentMethod.signNum || "null"}`
        : ""
      return this.payMethodsPromo && key ? this.payMethodsPromo[key]?.salePrice || 0 : 0
    },
    getCalcDataFromList(list) {
      if (!list) return {}
      const key = this.paymentMethod
        ? `${this.paymentMethod.paymentMethodId}_${this.paymentMethod.signNum || "null"}`
        : ""
      return list && key ? list[key] : {}
    },
    initStatus() {
      if (this.processInstance) {
        this.processInstance.destroy()
      }
    },
    async checkPromotion({ paymentNum, signNum }) {
      try {
        const res = await checkPromotion({
          orderId: this.orderNo,
          signNum: this.paymentMethod.signNum || signNum,
          orderPayPrice: this.salePrice,
          paymentNum,
          X_Merchant_Id: this.curMerchantId,
          X_Client_Key: clientKeyMap[this.curMerchantId]
        })
        if (!res.data) {
          this.$message.error(res?.message)
        }
        return res.data
      } catch (error) {
        console.log(error)
      }
    },
    async calcPromotionByBindCard() {
      this.loading = true
      try {
        const res = await calcPromotionByBindCard({
          orderId: this.orderNo,
          signNum: this.paymentMethod.signNum,
          paymentMethod: this.paymentMethod.paymentMethodId,
          cardNo: this.paymentMethod.cardNo,
          cardType: this.paymentMethod.cardType,
          transcationType: "bindCardPay",
          X_Merchant_Id: this.curMerchantId,
          X_Client_Key: clientKeyMap[this.curMerchantId]
        })
        return res.data
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async toPay() {
      try {
        let calcData
        if (this.paymentMethod.paymentMethodId !== 801) {
          this.payMethodsPromo = await this.calcPromotion()
          calcData = this.getCalcDataFromList(this.payMethodsPromo)
          this.salePrice = calcData.salePrice
        }
        this.paymentVisible = true
        this.$nextTick(async () => {
          const res = await this.$sdk.processPayment({
            container: "#payment-3ds-container",
            paymentMethod: this.paymentMethod,
            payData: calcData
              ? {
                  payAmount: calcData.salePrice,
                  merchantOrderId: this.orderNo,
                  paySecretData: calcData.paySecretDataStr,
                  orderPrice: calcData.orderPrice,
                  promoList: calcData.promoDiscountResponseList,
                  autoCancelOrderSeconds: calcData.autoCancelOrderSeconds
                }
              : null,
            onSuccess: res => {
              this.handlePaySuccess(res)
            },
            onError: err => {
              this.paymentVisible = false
              if (this.$route.path.includes("/pending_payment")) {
                this.$message.error(err)
              } else {
                this.handlePayFail()
              }
            },
            payConfirmCallback: res => this.checkPromotion(res)
          })
          this.paymentStatus = "confirm"
          this.processInstance = res?.instance
          if (res && res.payFn && res.payload) {
            this.paymentMethod.cardNo = res.payload.cardNo
            this.paymentMethod.cardType = res.payload.cardType
            calcData = await this.calcPromotionByBindCard()
            this.salePrice = calcData.salePrice
            await res.payFn({
              payAmount: calcData.salePrice,
              merchantOrderId: this.orderNo,
              paySecretData: calcData.paySecretDataStr,
              orderPrice: calcData.orderPrice,
              promoList: calcData.promoDiscountResponseList,
              autoCancelOrderSeconds: calcData.autoCancelOrderSeconds
            })
            this.paymentStatus = "pay"
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    handlePaySuccess() {
      this.$navigation.replace({
        path: "/payment_result",
        query: {
          orderNo: this.orderNo,
          orderList: this.orderList
        }
      })
    },
    handlePayFail() {
      this.$navigation.replace({
        path: "/pending_payment",
        query: {
          orderNo: this.orderNo,
          orderList: this.orderList,
          venderId: this.curMerchantId
        }
      })
    }
  }
}
